import { FolderAddOutlined } from '@ant-design/icons';
import { Form, Input } from 'antd';
import { observer } from 'mobx-react';
import React, { useState } from 'react';
import styled from 'styled-components';

import { ModalForm, type SubmitCallback } from 'components/UI/ModalForm';
import store from 'stores/RootStore';
import { normalizeInputSpace } from 'utils/String';

import DrawerButton from '../DrawerButton';

const FolderAddIcon = styled(FolderAddOutlined)`
  padding-top: 3px;
  font-size: 20px;
`;

function AddFolderButton() {
  const assetsManager = store.creative?.assets;

  const [isNamePromptOpen, setIsNamePromptOpen] = useState(false);

  const handleFormSubmit: SubmitCallback = async (values) => {
    // FIXME: This will create a folder in the root. The user *can*
    //  specify a slash/delimited name to basically do a `mkdir -p`. But I
    //  personally expect a more desktop-like UI where the new folder is
    //  created as a child of the folder I'm looking at.
    const folderPath = String(values.folderName).trimEnd();
    await assetsManager?.newFolder(folderPath);
  };

  return (
    <>
      <DrawerButton
        disabled={!assetsManager}
        onClick={() => setIsNamePromptOpen(true)}
      >
        <FolderAddIcon />
      </DrawerButton>

      <ModalForm
        formName="AddFolderModalForm"
        open={isNamePromptOpen}
        onClose={() => setIsNamePromptOpen(false)}
        onSubmit={handleFormSubmit}
        okText="Add"
        title="New Folder"
      >
        <Form.Item
          label="Folder name"
          name="folderName"
          normalize={(v) => normalizeInputSpace(v)}
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>
      </ModalForm>
    </>
  );
}

export default observer(AddFolderButton);
